import {httpClient} from "../utils";
export const endpointService ={
    ping
};

function ping(){    
      return httpClient.callApi("GET", "/ping");
}